import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import EmployeesPage from './pages/EmployeesPage';
import ReceiptsPage from './pages/ReceiptsPage';
import AuditPage from './pages/AuditPage';
import EmployeePortalPage from './pages/EmployeePortalPage';
import ThemeToggle from './components/ThemeToggle';
import LeavesPage from './pages/LeavesPage';
import MedicalCertificatesPage from './pages/MedicalCertificatesPage';
import NotificationCenter from './components/NotificationCenter';
import ReportsPage from './pages/ReportsPage';
import AdminCompaniesPage from './pages/AdminCompaniesPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const App: React.FC = () => {
  const { initialize, isAuthenticated } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter>
      <ThemeToggle />
      <NotificationCenter />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/recuperar-clave" element={<ForgotPasswordPage />} />
        <Route path="/restablecer-clave" element={<ResetPasswordPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/companies"
          element={
            <ProtectedRoute requiredRole="SUPERADMIN">
              <AdminCompaniesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mi-portal"
          element={
            <ProtectedRoute requiredRole="EMPLOYEE">
              <EmployeePortalPage />
            </ProtectedRoute>
          }
        />
        {[
          ['/employees', <EmployeesPage />],
          ['/receipts', <ReceiptsPage />],
          ['/audit', <AuditPage />],
          ['/leaves', <LeavesPage />],
          ['/medical-certificates', <MedicalCertificatesPage />],
          ['/reports', <ReportsPage />],
        ].map(([path, element]) => (
          <Route
            key={path as string}
            path={path as string}
            element={<ProtectedRoute>{element as React.ReactElement}</ProtectedRoute>}
          />
        ))}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate
                to={
                  useAuthStore.getState().user?.roles?.includes('EMPLOYEE')
                    ? '/mi-portal'
                    : '/dashboard'
                }
              />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="*" element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
